<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.location.add')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/location"><span>{{$t('tlt.location')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/location/edit"><span>{{$t('tlt.location.new')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('location')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('location')"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.code')}}:</label>
                                <input class="form-control form-control-sm" v-model="code" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.name')}}:</label>
                                <input class="form-control form-control-sm" v-model="locName" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.type')}}:</label>
                                <select class="form-control form-control-sm" 
                                :disabled="typeDisabled"
                                @click.native.stop @change="disableHierarchy" v-model="locType">
                                        <option value="-1">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="E">{{ $t("lbl.location.enterprise") }}</option>                                                               
                                        <option value="S">{{ $t("lbl.location.site") }}</option>  
                                        <option value="A">{{ $t("lbl.location.area") }}</option>                                       
                                        <option value="W">{{ $t("lbl.location.workCenter") }}</option>
                                </select>
                            </div>
                            <!-- <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.active')}}:</label>
                                <select class="form-control form-control-sm" v-model="active">
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                            </div> -->
                        </div>
                        <div class="row">                           
                            <div class="form-group col-md-3">
                                <label class="control-label">{{$t('lbl.location.enterprise')}}:</label>
                                <select class="form-control form-control-sm" v-model="enterprise"
                                :disabled="enterpriseDisabled"
                                @click.native.stop @change="selectParentLocal('E')">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option v-for="child in enterpriseCBO" 
                                        :value="child.id" :key=child.id>{{child.locName}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-3">
                                <label class="control-label">{{$t('lbl.location.site')}}:</label>
                                <select class="form-control form-control-sm" v-model="site"
                                :disabled="siteDisabled"
                                @click.native.stop @change="selectParentLocal('S')">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option v-for="child in siteCBO" 
                                        :value="child.id" :key=child.id>{{child.locName}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-3">
                                <label class="control-label">{{$t('lbl.location.area')}}:</label>
                                <select class="form-control form-control-sm" v-model="area"
                                :disabled="areaDisabled" 
                                @click.native.stop @change="selectParentLocal('A')">
                                        <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                        <option v-for="child in areaCBO" 
                                        :value="child.id" :key=child.id>{{child.locName}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
 </template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions, mapState } from "vuex";
import {fields}  from "@/model/master/Location";

const { mapFields } = createHelpers({
  getterType: 'location/getField',
  mutationType: 'location/updateField',
});
export default {
  data () {
    return {
      enterpriseDisabled: true,
      siteDisabled: true,
      areaDisabled: true,
      workCenterDisabled: true,
      typeDisabled: true
    }
  },
  computed: {
    ...mapFields(fields),
    ...mapState({
        enterpriseCBO: state => state.location.enterpriseCBO,
        siteCBO: state => state.location.siteCBO,
        areaCBO: state => state.location.areaCBO,
        workCenterCBO: state => state.location.workCenterCBO
    })
  },
  mounted(){
     this.typeDisabled = (this.$store.state.location.crudState == 'edit');
      if( !this.typeDisabled){
          this.disableHierarchy();
      }
  },
  methods: {
    ...mapActions("location", ["loadLocationByType", "selectParentLocal"]),
    ...mapActions("base", ["MMFbackToList", "MMFSave", "MMFCheckState"]),
    disableHierarchy(){
        this.enterpriseDisabled= true;
        this.siteDisabled = true;
        this.areaDisabled =  true;
        this.workCenterDisabled =  true;

        this.$store.commit("location/setEnterpriseCBO", []);
        this.$store.commit("location/setSiteCBO", []);
        this.$store.commit("location/setAreaCBO", []);
        this.$store.commit("location/setWorkCenterCBO", []);

        var enty1 = JSON.parse(JSON.stringify(this.$store.state.location.entity));
        enty1.enterprise = "";
        enty1.site = "";
        enty1.area = "";
        enty1.workCenter = "";

        this.$store.commit("location/setEntity", enty1);

        switch (this.$store.state.location.entity.locType) {
            case 'E':
            break;
            case 'S':
                this.enterpriseDisabled= false;
            break;
            case 'A':
                this.enterpriseDisabled= false;
                this.siteDisabled = false;
            break;
            case 'W':
                this.enterpriseDisabled= false;
                this.siteDisabled = false;
                this.areaDisabled =  false;    
            break;
        }
         this.$store.dispatch('location/loadLocationByType', {type: 'E', idLoc : 0} );
    }
  }
};
</script>